<app-vertical-layout [layoutWidth]="layoutSize" [layoutColor]="layoutColor" *ngIf="layoutType==='vertical'">
</app-vertical-layout>

<app-horizontal-layout [layoutWidth]="layoutSize" [layoutColor]="layoutColor" *ngIf="layoutType==='horizontal'">
</app-horizontal-layout>